import React, { useEffect, useState } from 'react';
import caseStudiesData from '../data/caseStudiesData';
import NavbarM from '../components/Navbar';
import Footer from '../components/Footer';
import FadeIn from '../components/FadeIn';
import mainLogo from '../img/mainLogo.svg';

const CaseStudiesPage = () => {
    const [scroll, setScroll] = useState(false);
    const [expandedIndex, setExpandedIndex] = useState(null);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const handleScroll = () => setScroll(window.scrollY > 100);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <div className='heroMain'>
                <div className={`heroSec heroSec--inner ${scroll ? 'heroSec__' : ''}`}>
                    <NavbarM logo={mainLogo} setNewsPage={() => {}} />
                </div>
                {expandedIndex !== null ? (
                    <div className='caseStudiesPage__fullPage'>
                        <button
                            className='caseStudiesPage__backBtn'
                            onClick={() => setExpandedIndex(null)}
                        >
                            ← See all case studies
                        </button>
                        <img
                            src={caseStudiesData[expandedIndex].caseStudyImg}
                            alt={caseStudiesData[expandedIndex].title}
                        />
                    </div>
                ) : (
                    <div className='container' style={{ paddingTop: '150px', paddingBottom: '60px', borderRadius: '30px' }}>
                        <FadeIn direction='up'>
                            <h1 className='latestNewsPage__title text-center'>Case Studies</h1>
                        </FadeIn>
                        <div className='caseStudiesPage__list'>
                            {caseStudiesData.map((item, index) => (
                                <FadeIn key={index} as='article' direction='up' delay={index * 100} className='caseStudiesPage__item'>
                                    <div className='caseStudiesPage__itemImg'>
                                        <img src={item.img} alt={item.title} style={item.imgStyle || {}} />
                                    </div>
                                    <div className='caseStudiesPage__itemBody'>
                                        <h2 className='caseStudiesPage__itemTitle'>{item.title}</h2>
                                        <p className='caseStudiesPage__itemDesc'>{item.description}</p>
                                        {item.caseStudyImg && (
                                            <button
                                                className='caseStudiesPage__itemCta'
                                                onClick={() => setExpandedIndex(index)}
                                            >
                                                View case study →
                                            </button>
                                        )}
                                    </div>
                                </FadeIn>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            <Footer />
        </>
    );
};

export default CaseStudiesPage;
